import Vue from 'vue';
import VueI18n from 'vue-i18n';
import api from '@a'; // api接口
import ElementLocale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhUx from 'jimi-uxkit/packages/language/zh';
import enUx from 'jimi-uxkit/packages/language/en';
import Cookies from 'js-cookie'; // cookie插件
import options from '@l/options.js'; // 各种选项配置文件

ElementLocale.i18n((key, value) => i18n.t(key, value));

Vue.use(VueI18n);
const messages = {
  zh: { ...zhUx, ...zhLocale, ...require('./zh.json') },
  en: { ...enUx, ...enLocale, ...require('./en.json') }
};

const i18n = new VueI18n({
  locale: Cookies.get('locale') || 'en',
  messages
});

// 异步加载语言包
async function loadLanguageAsync(lang) {
  Cookies.set('locale', lang || 'en');
  const oldLangJsons = localStorage.getItem('i18n-' + lang); // json对象
  i18n.locale = lang;

  if (oldLangJsons) {
    // 存了一份 先设置 等接口返回再更新一次
    const data = { ...JSON.parse(oldLangJsons) };
    i18n.mergeLocaleMessage(lang, data);
  }

  const langMap = {
    en: 'en_US',
    zh: 'zh_CN'
  };

  const params = {
    lang: langMap[lang],
    scene: '1'
  };

  // 没有就拿新的
  const newLangData = await api.language.getI18nJson(params);
  const data = { ...newLangData.data.data };
  localStorage.setItem('i18n-' + lang, JSON.stringify(data));
  i18n.mergeLocaleMessage(lang, data);
  Vue.prototype.$opt = options(); // 更新下拉框的数据
  return lang;
}

// 在手动切换语言时调用此方法，页面初始化时需加载一个默认语言，在APP.vue执行一次
Vue.prototype.$loadLanguageAsync = loadLanguageAsync;
export default i18n;
